module.exports = __webpack_public_path__ + "static/media/BOE.e03370f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/BOE.mp4
// module id = dOXF
// module chunks = 0